import React from "react";
import { Target } from "lucide-react";

const statusStyle = (status) => ({
  background:
    status === "Completed"  ? "rgba(16,185,129,0.2)"  :
    status === "In Progress"? "rgba(59,130,246,0.2)"  :
                              "rgba(245,158,11,0.2)",
  color:
    status === "Completed"  ? "#34d399" :
    status === "In Progress"? "#60a5fa" :
                              "#fbbf24",
});

const ProjectsTab = ({
  styles,
  screenSize,
  employeeData,
  handleMouseEnter,
  handleMouseLeave,
  t,
  getProjectStatus,
}) => (
  <div style={styles.singleColumn}>
    <div style={styles.card} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <h3 style={styles.cardTitle}>
        <Target size={screenSize.isMobile ? 18 : 24} />
        {t("currentProjects")}
      </h3>
      <div style={styles.threeColumn}>
        {employeeData.projects.map((project, i) => (
          <div key={i} style={styles.projectItem}>
            <div style={styles.projectHeader}>
              <div style={styles.projectName}>{project.name}</div>
              <div style={{ ...styles.projectStatus, ...statusStyle(project.status) }}>
                {getProjectStatus(project.status)}
              </div>
            </div>
            <div style={styles.projectTech}>{project.tech}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ProjectsTab;